const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'fare_option_info',
    viewClass: require('./view'),
});
